import React from "react";
import { Row, Col, TimePicker, Collapse, Card, Avatar, Tooltip } from "antd";
import "./TimelineListElement.css";
import WeekdayScheduler from "./WeekdayScheduler";
import WeekdaySchedulerItem from "./WeekdaySchedulerItem";
import moment from "moment";
import LayoutPreview from "./views/LayoutPreview";
import ActionButton from "../components/ActionButton";
import { connect } from "react-redux";
import { requestServerPost, selectPage } from "../actions";
import MomentHelper from "../helpers/MomentHelper";
import {
  EditOutlined,
  EllipsisOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Layers } from "lucide-react";
import { useProLanguage, PRO_TRANSLATIONS } from "../global/ProLanguageContext";
const { Panel } = Collapse;
const { Meta } = Card;
function TimelineListElement(props) {
  const {
    data,
    onClick = () => {},
    onEdit = () => {},
    onDelete = () => {},
    onDuplicate = () => {},
    index = 0,
    onTimelineUpdated = () => {},
    allowEdit = true,
    allowDelete = true,
  } = props;

  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.timelinePage || PRO_TRANSLATIONS.en.timelinePage;

  const { Timelinelayouts, Timelineschedules, TimelineID } = data;
  const ordering = index + 1;
  const inputformat = "HH:mm:ss";

  if (!Timelinelayouts) return null;

  const TLLO = Timelinelayouts[0];

  // if (!Timelinelayouts)
  //     return null;

  // const onDurationChanged = (newDurationMoment) => {
  //     const { requestServerPost, usertoken, selectedBrandData } = props;

  //     const newDuration = MomentHelper.getSecondsDuration(newDurationMoment);

  //     const params = new FormData();

  //     params.append("timelinelayoutid", TLLO.TLLID)
  //     params.append("duration", newDuration)
  //     // params.append("startplaytime", TLLO.startplaytime ? TLLO.startplaytime : "");
  //     params.append("brandid", selectedBrandData.BrandID)

  //     requestServerPost("update_timelinelayout", params, { }, (response) => {
  //     }, usertoken);
  // }

  if (!Timelineschedules) return null;

  const duration = TLLO ? parseInt(TLLO.Duration) : 0;
  const momentDuration = moment.utc(
    moment.duration(duration, "seconds").asMilliseconds(),
  );
  // const renderLayoutPreview = TLLO ? (<LayoutPreview size={120} layoutData={TLLO.Layout}></LayoutPreview>) : null
  const renderDefaultLayoutPreview = TLLO ? (
    <LayoutPreview size={120} layoutData={TLLO.Layout}></LayoutPreview>
  ) : null;
  const renderLayoutPreview = TLLO ? (
    <LayoutPreview size={80} layoutData={TLLO.Layout}></LayoutPreview>
  ) : null;
  // console.log("parseInt(Timelinelayouts.Duration) " + moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format('HH:mm:ss'))
  return (
    // <div className="media-list-element">
    //     <img alt={icon} style={{ marginLeft: "20px", width: "80px", height: "80%", margin: "auto", objectFit: "contain" }} className="media-thumb" src={icon}></img>
    //     <div style={{ flex: 1 }} className="media-name center-content"><div style={{ display: "inline-block" }}>{FileName}</div> </div>
    //     <div style={{ flex: 1 }} className="media-name center-content">{type} </div>
    //     <div style={{ flex: 1 }} className="media-name center-content">{size} </div>
    //     <div style={{ flex: 0.5 }} className="element-btn-container center-content">
    //         <Button shape="circle" icon={<EyeOutlined />} size="medium" onClick={onPreviewClick} />
    //         <Button type="danger" shape="circle" icon={<DeleteOutlined />} size="medium" onClick={onDeleteClick} />
    //     </div>
    // </div>
    <Row className="list-element" style={{ width: "100%" }}>
      <Col
        flex="10px"
        style={{
          backgroundColor: data.color,
          borderRadius: "6px",
          minHeight: "40px",
        }}
      ></Col>
      <Col span={22}>
        <Row
          className="aloha"
          gutter={[8, 8]}
          align="middle"
          justify="space-around"
          style={{ margin: "0px" }}
        >
          {/* order number */}
          <Col xs={3} sm={3} md={3} lg={3} xl={1}>
            <span
              style={{
                display: "inline-flex",
                width: 26,
                height: 26,
                borderRadius: 8,
                background: "#f1f5f9",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                fontWeight: 700,
                color: "#94a3b8",
              }}
            >
              {ordering}
            </span>
          </Col>
          {/* name + icon */}
          <Col
            xs={21}
            sm={21}
            md={21}
            lg={12}
            xl={4}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              minWidth: 0,
            }}
          >
            <div
              onClick={onClick}
              style={{
                width: 36,
                height: 36,
                borderRadius: 9,
                background: data.color || "#6366f1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: "pointer",
              }}
            >
              <Layers size={16} color="#fff" />
            </div>
            <Tooltip title={data.TimelineName}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                  fontWeight: 600,
                  color: "#0f172a",
                  fontSize: "14px",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <a style={{ color: "#0f172a" }} onClick={onClick}>
                  {data.TimelineName}
                </a>
              </div>
            </Tooltip>
          </Col>
          {/* schedule */}
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={7}
            style={{ pointerEvents: allowEdit ? "auto" : "none" }}
          >
            <WeekdayScheduler onSaved={onTimelineUpdated} data={data} />
          </Col>
          {/* layout preview */}
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={5}
            style={{
              pointerEvents: allowEdit ? "auto" : "none",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={onClick}
          >
            {renderDefaultLayoutPreview}
          </Col>
          {/* actions */}
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={3}
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
            }}
          >
            <ActionButton
              onClicked={() => onEdit(TimelineID)}
              visible={allowDelete}
              title={t.tooltipEdit}
              showTitle={false}
              icon="/cms/assets/svgs/icons/edit_icon.svg"
            />
            <ActionButton
              onClicked={() => onDuplicate(TimelineID)}
              visible={allowDelete}
              title={t.tooltipDuplicate}
              showTitle={false}
              icon="/cms/assets/svgs/icons/duplicate_icon.svg"
            />
            <ActionButton
              danger={true}
              visible={allowEdit}
              confirmText={t.deleteConfirm}
              onClicked={() => onDelete(TimelineID)}
              title={t.tooltipDelete}
              showTitle={false}
              icon="/cms/assets/svgs/icons/trash_icon.svg"
            />
          </Col>
        </Row>
      </Col>
      <Col
        className="column-drag-handle"
        span={1}
        style={{
          display: "flex",
          cursor: "grab",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: allowEdit ? "auto" : "none",
          color: "#cbd5e1",
        }}
      >
        <span
          style={{
            display: "inline-block",
            pointerEvents: "none",
            fontSize: 16,
          }}
        >
          &#x2630;
        </span>
      </Col>
    </Row>
  );
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

export default connect(mapStateToProps, {
  requestServerPost,
  requestServerPost,
  selectPage,
})(TimelineListElement);
